import { Group, Image, Box } from '@mantine/core';
import forvetLogo from '../../assets/logo-forvet-dark.svg';
import ipgLogo from '../../assets/grand/ipg-logo-lockup.png';

/**
 * El lockup de marca del evento: FORVET e IPG, juntos y con el mismo peso.
 *
 * Existe como componente y no suelto en cada pantalla porque el stand es de los
 * dos y la paridad tiene que sobrevivir a que alguien toque una pantalla sola.
 * Antes la página pública de gemelos —la que la persona abre en su celular
 * desde el WhatsApp, o sea la que más se ve fuera del stand— mostraba solo
 * FORVET.
 *
 * Sobre los tamaños: las dos marcas NO van a la misma altura en px. FORVET es
 * un logotipo horizontal (ratio 4,3:1) e IPG es un bloque apilado, isotipo
 * arriba y "Iribarren" abajo (1,3:1). A igual altura el apilado se lee bastante
 * más chico, así que va un 33% más alto para que pesen parecido. Eso es lo que
 * quiere decir "iguales" acá: peso óptico, no el mismo número.
 *
 * (El valor viejo en el kiosco era FORVET 46 e IPG 120 — casi el triple. No era
 * criterio de diseño: el PNG anterior era un cuadrado de 225×225 en el que la
 * marca real ocupaba el 57% del ancho y el 44% del alto, todo lo demás
 * transparente. Había que agrandarlo mucho para compensar el aire. El asset
 * nuevo viene recortado al contenido, así que la altura que se pide es la
 * altura que se ve.)
 *
 * @param {number}  h       altura en px del logotipo de FORVET; IPG se deriva.
 * @param {boolean} conIpg  false deja solo FORVET, sin el filete ni el hueco.
 *                          Lo usa Caso Abierto, que sobrevive al congreso: ver
 *                          CASOS_CON_IPG en utils/cvdl.js.
 */
export function LogosEvento({ h = 44, justify = 'center', conIpg = true, ...props }) {
  const hIpg = Math.round(h * 1.33);

  if (!conIpg) {
    return (
      <Group justify={justify} align="center" wrap="nowrap" {...props}>
        <Image src={forvetLogo} alt="FORVET" h={h} w="auto" fit="contain" />
      </Group>
    );
  }

  return (
    <Group justify={justify} align="center" gap="lg" wrap="nowrap" {...props}>
      <Image src={forvetLogo} alt="FORVET" h={h} w="auto" fit="contain" />
      <Box
        aria-hidden
        style={{
          width: 1,
          height: hIpg * 0.62,
          background: 'currentColor',
          opacity: 0.18,
          flexShrink: 0,
        }}
      />
      <Image src={ipgLogo} alt="IPG Iribarren" h={hIpg} w="auto" fit="contain" />
    </Group>
  );
}
